import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_CONTENT,
    UPDATE_CONTENT,
    CREATE_CONTENT, DELETE_CONTENT
} from 'constants/contents.constants'
import axios from 'axios'
import {
    fetchContentsSuccess,
    updateContentSuccess,
    createContentSuccess,
    deleteContentSuccess
} from "actions/contents.action";
import { showErrors, stopLoader } from "actions/general.action";


// content sagas

const fetchContentsRequest = async (page) => {
    return axios.get('/api/v1/super_admin/contents');
}

function* fetchContents({ payload }) {
    try {
        const reuslt = yield call(fetchContentsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchContentsSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updateContentsRequest = async (payload) => {
    let o = {name: payload.name}
    o.name = payload.name
    o.content_type = {id: payload.content_type_id}
    o.country = {id: payload.country_id}
    o.contents = []
    console.log(payload);
    for (const z of payload.country.langs){
        let c = payload.contents.find(c => c.language.id === z.id);
        if (c !== null || c!== undefined) {
            o.contents.push({id: payload.contents.find(c => c.language.id === z.id).id , content_text: payload["value"+z.id], language: {id: z.id}, content_id:payload.id, content:{id: payload.id}})
        } else {
            o.contents.push({content_text: payload["value"+z.id], language: {id: z.id}, content_id:payload.id, content:{id: payload.id}})
        }
    }

    return axios.put('/api/v1/super_admin/contents/' + payload.id,
        o
    );
}

function* updateContent({ payload }) {
    try {
        const reuslt = yield call(updateContentsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateContentSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createContentsRequest = async (payload) => {
    let o = {name: payload.name}
    o.name = payload.name
    o.content_type = {id: payload.content_type_id}
    o.country = {id: payload.country_id}
    o.contents = []
    for (const z of payload.country.langs){
        o.contents.push({content_text: payload["value"+z.id], language: {id: z.id}})
    }

    return axios.post('/api/v1/super_admin/contents',
        o
    );
}

function* createContent({ payload }) {
    try {
        const reuslt = yield call(createContentsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createContentSuccess(reuslt.data)),
                //put(stopLoader("Content created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deleteContentsRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/contents/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteContent({ payload }) {
    try {
        const reuslt = yield call(deleteContentsRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteContentSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}


// fork content
export function* forkFetchContents() {
    yield takeEvery(FETCH_ALL_CONTENT, fetchContents);
}

export function* forkUpdateContent() {
    yield takeEvery(UPDATE_CONTENT, updateContent);
}

export function* forkCreateContent() {
    yield takeEvery(CREATE_CONTENT, createContent);
}

export function* forkDeleteContent() {
    yield takeEvery(DELETE_CONTENT, deleteContent);
}


export default function* rootSaga() {
    yield all([
        fork(forkFetchContents),
        fork(forkUpdateContent),
        fork(forkCreateContent),
        fork(forkDeleteContent),
    ]);
}